import { render, staticRenderFns } from "./BenefitsNav.vue?vue&type=template&id=2c4760eb&scoped=true&"
import script from "./BenefitsNav.vue?vue&type=script&lang=js&"
export * from "./BenefitsNav.vue?vue&type=script&lang=js&"
import style0 from "./BenefitsNav.vue?vue&type=style&index=0&id=2c4760eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4760eb",
  null
  
)

export default component.exports